import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import usePortalModal from 'hooks/usePortalModal';

const useCameraMaskToCapturePhoto = () => {
  const { showPortalModalName, closePortalModalName } = usePortalModal();

  const handleShowCustomCameraMaskToCapturePhotoModal = ({
    field,
    information,
    setInformation,
  }) => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.CUSTOM_CAMERA_MASK_TO_CAPTURE_PHOTO_MODAL,
        modalData: {
          field,
          information,
          setInformation,
        },
      });
      clearTimeout(timer);
    }, 100);
  };

  const handleShowCheckCameraToTakePhotoEnableAlertModal = () => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.CHECK_CAMERA_TO_TAKE_PHOTO_ENABLE_ALERT_MODAL,
      });
      clearTimeout(timer);
    }, 100);
  };

  return {
    handleShowCustomCameraMaskToCapturePhotoModal,
    handleShowCheckCameraToTakePhotoEnableAlertModal,
  };
};

export default useCameraMaskToCapturePhoto;
